import { Link, useLocation } from 'react-router-dom'
import { Home, PawPrint, Users, ClipboardList, User, LucideIcon } from 'lucide-react'

interface NavItem {
  path: string
  label: string
  icon: LucideIcon
  exact?: boolean
}

interface BottomNavProps {
  items?: NavItem[]
  className?: string
}

const defaultItems: NavItem[] = [
  { path: '/', label: 'Inicio', icon: Home, exact: true },
  { path: '/mascotas', label: 'Mascotas', icon: PawPrint },
  { path: '/grupo', label: 'Grupo', icon: Users },
  { path: '/bitacora', label: 'Bitácora', icon: ClipboardList },
  { path: '/perfil', label: 'Perfil', icon: User },
]

export function BottomNav({ items = defaultItems, className = '' }: BottomNavProps) {
  const location = useLocation()

  const isActive = (item: NavItem) => {
    if (item.exact) {
      return location.pathname === item.path
    }
    return location.pathname === item.path || location.pathname.startsWith(item.path + '/')
  }

  return (
    <nav className={`bottom-nav ${className}`} aria-label="Navegación principal">
      {items.map((item) => {
        const Icon = item.icon
        const active = isActive(item)
        return (
          <Link
            key={item.path}
            to={item.path}
            className={`bottom-nav__item ${active ? 'bottom-nav__item--active' : ''}`}
            aria-current={active ? 'page' : undefined}
          >
            <Icon size={24} className="bottom-nav__icon" />
            <span className="bottom-nav__label">{item.label}</span>
          </Link>
        )
      })}
    </nav>
  )
}
